"use client"
import React from "react";
import { useTranslations } from 'next-intl';
import ButtonCheckout from "@/components/ButtonCheckout";

const OneTimePlan = ({ plan }) => {
  const t = useTranslations('Pricing');

  // 获取一次性计划的功能列表
  const getPlanFeatures = (planName) => {
    if (planName === 'Onetime') {
      return [
        { name: t('plans.Onetime.features.0.name'), included: true },
        { name: t('plans.Onetime.features.1.name'), included: true },
        { name: t('plans.Onetime.features.2.name'), included: true },
        { name: t('plans.Onetime.features.3.name'), included: true },
        { name: t('plans.Onetime.features.4.name'), included: true }
      ];
    }
    return [];
  };

  const features = getPlanFeatures(plan.name);

  return (
    <div className="mb-8">
      <div className="text-center mb-4">
        <h3 className="text-xl md:text-2xl font-bold text-white mb-2">
          <span className="bg-gradient-to-r from-green-400 to-cyan-400 text-transparent bg-clip-text drop-shadow-[0_0_10px_rgba(168,85,247,0.3)]">
            {t('oneTimeTitle') || 'One-time Purchase'}
          </span>
        </h3>
        <p className="text-sm text-gray-400">
          {t('oneTimeSubtitle') || 'Perfect for trying out our service'}
        </p>
      </div>
      <div className="max-w-md mx-auto">
        <div className="relative transition-all duration-300 hover:-translate-y-1 hover:scale-[1.01] group">
          <div className="h-full p-4 md:p-6 rounded-xl backdrop-blur-md transition-all bg-black/60 border-2 border-green-400/20 shadow-md group-hover:shadow-[0_0_20px_rgba(168,85,247,0.2)] group-hover:border-green-400/40">
            <h3 className="text-lg md:text-xl font-bold text-white mb-1">{t(`plans.${plan.name}.name`)}</h3>
            <p className="text-gray-400 text-xs md:text-sm mb-4">{t(`plans.${plan.name}.description`)}</p>
            
            <div className="mb-4">
              <p className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-green-400 to-cyan-400 text-transparent bg-clip-text drop-shadow-[0_0_5px_rgba(168,85,247,0.3)]">
                ${plan.price}
              </p>
            </div>

            <div className="mb-4">
              <ButtonCheckout
                plan={plan}
                isYearly={false}
                mode="payment"
                className="w-full py-2 rounded-lg font-medium transition-all duration-300 hover:scale-[1.02] bg-black border-2 border-green-400/40 text-white hover:bg-green-400/10 hover:border-green-400/70"
              >
                {t('buyNow')}
              </ButtonCheckout>
            </div>

            <ul className="space-y-2">
              {features.map((feature, featureIndex) => (
                <li key={featureIndex} className="flex items-start">
                  {feature.included ? (
                    <svg className="w-4 h-4 text-green-400 flex-shrink-0 mr-2 mt-0.5 drop-shadow-[0_0_3px_rgba(168,85,247,0.3)]" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" />
                    </svg>
                  ) : (
                    <svg className="w-4 h-4 text-gray-600 flex-shrink-0 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  )}
                  <span className={`text-xs md:text-sm ${feature.included ? 'text-gray-300' : 'text-gray-500'}`}>
                    {feature.name.split(/(\d+\s*(?:credits|task|tasks|s)(?:\s*per\s*\w+)?|\d+)/i).map((part, i) => {
                      if (/\d+\s*(?:credits|task|tasks|s)(?:\s*per\s*\w+)?|\d+/i.test(part)) {
                        return (
                          <span key={i} className="font-bold bg-gradient-to-r from-cyan-400 to-green-400 text-transparent bg-clip-text drop-shadow-[0_0_5px_rgba(236,72,153,0.4)]">
                            {part}
                          </span>
                        );
                      }
                      return part;
                    })}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OneTimePlan; 